import {Component} from 'react';
import h from 'react-hyperscript';
import AnnouncementBar from 'Components/AnnouncementBar/AnnouncementBar';
import content from 'Assets/data/gdpr-announcement.json';

class GdprAnnouncement extends Component {
  handleClick() {
    window.localStorage.setItem('accepted-cookies', true);
  }

  checkCookieAccept() {
    return !window.localStorage.getItem('accepted-cookies');
  }

  render() {
    return (
      h(AnnouncementBar, {
        className: 'cookies-notice',
        checkActive: this.checkCookieAccept.bind(this),
        desc: content.desc,
        link: content.link,
        button: Object.assign({}, content.button, {
          onClick: this.handleClick.bind(this),
        }),
      }, null)
    );
  }
}

export default GdprAnnouncement;
